(function () {
  var currentlyViewingIntervals = {};
  var countdownIntervals = {};

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function parseRange(fromValue, toValue) {
    var from = Number.parseInt(fromValue, 10);
    var to = Number.parseInt(toValue, 10);

    if (!Number.isFinite(from) || !Number.isFinite(to)) {
      return null;
    }

    if (to < from) {
      var tmp = to;
      to = from;
      from = tmp;
    }

    return { from: from, to: to };
  }

  function initCurrentlyViewing(context) {
    var components = context.querySelectorAll('[data-currently-viewing]');

    components.forEach(function (component) {
      var valueElement = component.querySelector('[data-currently-viewing-value]');
      var range = parseRange(component.dataset.fromVisitors, component.dataset.toVisitors);
      var widgetKey = component.dataset.widgetKey || '';

      if (!valueElement || !range) {
        return;
      }

      if (widgetKey && currentlyViewingIntervals[widgetKey]) {
        clearInterval(currentlyViewingIntervals[widgetKey]);
      }

      var viewingCount = randomInt(range.from, range.to);
      valueElement.textContent = String(viewingCount);

      var minViewingCount = Math.max(range.from, viewingCount - 6);
      var maxViewingCount = viewingCount + 6;

      var interval = setInterval(function () {
        var nextCount = viewingCount + (Math.random() < 0.5 ? -1 : 1);
        if (nextCount >= minViewingCount && nextCount <= maxViewingCount) {
          viewingCount = nextCount;
          valueElement.textContent = String(viewingCount);
        }
      }, randomInt(8000, 16000));

      if (widgetKey) {
        currentlyViewingIntervals[widgetKey] = interval;
      }
    });
  }

  function initInventoryCount(context) {
    var components = context.querySelectorAll('[data-inventory-count]');

    components.forEach(function (component) {
      var inStockElement = component.querySelector('[data-inventory-state="in-stock"]');
      var outOfStockElement = component.querySelector('[data-inventory-state="out-of-stock"]');
      var valueElement = component.querySelector('[data-stock-left]');
      var range = parseRange(component.dataset.fromStock, component.dataset.toStock);

      if (!valueElement || !range) {
        return;
      }

      if (inStockElement) {
        inStockElement.style.display = '';
      }
      if (outOfStockElement) {
        outOfStockElement.style.display = 'none';
      }

      valueElement.textContent = String(randomInt(range.from, range.to));
    });
  }

  function updateInventoryCountForSection(sectionRoot, variant) {
    if (!sectionRoot || !sectionRoot.querySelectorAll) {
      return;
    }

    var components = sectionRoot.querySelectorAll('[data-inventory-count]');
    if (!components.length) {
      return;
    }

    components.forEach(function (component) {
      var inStockElement = component.querySelector('[data-inventory-state="in-stock"]');
      var outOfStockElement = component.querySelector('[data-inventory-state="out-of-stock"]');
      var valueElement = component.querySelector('[data-stock-left]');
      var range = parseRange(component.dataset.fromStock, component.dataset.toStock);

      if (!valueElement || !range || !inStockElement || !outOfStockElement) {
        return;
      }

      if (!variant || variant.available === false) {
        inStockElement.style.display = 'none';
        outOfStockElement.style.display = 'block';
        return;
      }

      outOfStockElement.style.display = 'none';
      inStockElement.style.display = 'block';
      valueElement.textContent = String(randomInt(range.from, range.to));
    });
  }

  function bindInventoryVariantListeners(context) {
    var roots = context.querySelectorAll('[data-section-type="product"]');

    roots.forEach(function (sectionRoot) {
      if (sectionRoot.dataset.inventoryVariantBound === 'true') {
        return;
      }

      sectionRoot.dataset.inventoryVariantBound = 'true';

      if (window.jQuery) {
        window.jQuery(sectionRoot).on('variantChange', function (event) {
          var changedVariant = event && event.variant ? event.variant : null;
          updateInventoryCountForSection(sectionRoot, changedVariant);
        });
      }
    });
  }

  function formatCountdownTime(totalSeconds) {
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return (
      String(hours).padStart(2, '0') +
      'h : ' +
      String(minutes).padStart(2, '0') +
      'm : ' +
      String(seconds).padStart(2, '0') +
      's'
    );
  }

  function normalizeDateTimeInput(value) {
    if (!value) {
      return '';
    }

    var normalized = String(value).trim();
    if (!normalized) {
      return '';
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
      return normalized + 'T23:59:59';
    }

    if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}$/.test(normalized)) {
      return normalized.replace(/\s+/, 'T') + ':00';
    }

    if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}$/.test(normalized)) {
      return normalized.replace(/\s+/, 'T');
    }

    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(normalized)) {
      return normalized + ':00';
    }

    return normalized;
  }

  function parseCountdownDate(value) {
    var normalized = normalizeDateTimeInput(value);
    if (!normalized) {
      return null;
    }

    var parsedDate = new Date(normalized);
    if (Number.isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate;
  }

  function initCountdownTimers(context) {
    var components = context.querySelectorAll('[data-countdown-timer]');

    components.forEach(function (component) {
      var displayElement = component.querySelector('[data-countdown-display]');
      var countdownMode = component.dataset.countdownMode || 'minutes';
      var minuteCount = Number.parseInt(component.dataset.minuteCount, 10);
      var loopTimer = component.dataset.loopTimer === 'true';
      var countdownKey = component.dataset.countdownKey || 'default';
      var endedText = component.dataset.endedText || 'The sale has ended!';
      var endDateTime = component.dataset.endDatetime;

      if (!displayElement) {
        return;
      }

      if (countdownIntervals[countdownKey]) {
        clearInterval(countdownIntervals[countdownKey]);
      }

      if (countdownMode === 'date') {
        var targetDate = parseCountdownDate(endDateTime);

        if (!targetDate) {
          displayElement.textContent = endedText;
          return;
        }

        function updateDateCountdown() {
          var now = new Date();
          var remainingSeconds = Math.floor((targetDate.getTime() - now.getTime()) / 1000);

          if (remainingSeconds <= 0) {
            clearInterval(countdownIntervals[countdownKey]);
            displayElement.textContent = endedText;
            return;
          }

          displayElement.textContent = formatCountdownTime(remainingSeconds);
        }

        updateDateCountdown();
        countdownIntervals[countdownKey] = setInterval(updateDateCountdown, 1000);
        return;
      }

      if (!Number.isFinite(minuteCount) || minuteCount <= 0) {
        displayElement.textContent = endedText;
        return;
      }

      var initialCountdownTimeInSeconds = minuteCount * 60;
      var storedSecondsKey = 'skyrocket_countdown_seconds_' + countdownKey;
      var storedMinutesKey = 'skyrocket_countdown_minutes_' + countdownKey;

      var countdownTimeInSeconds = Number.parseInt(
        sessionStorage.getItem(storedSecondsKey),
        10
      );
      var storedMinuteCount = Number.parseInt(sessionStorage.getItem(storedMinutesKey), 10);

      if (
        !Number.isFinite(countdownTimeInSeconds) ||
        countdownTimeInSeconds <= 0 ||
        storedMinuteCount !== minuteCount
      ) {
        countdownTimeInSeconds = initialCountdownTimeInSeconds;
        sessionStorage.setItem(storedMinutesKey, String(minuteCount));
        sessionStorage.setItem(storedSecondsKey, String(countdownTimeInSeconds));
      }

      displayElement.textContent = formatCountdownTime(countdownTimeInSeconds);

      var interval = setInterval(function () {
        if (countdownTimeInSeconds <= 0) {
          if (loopTimer) {
            countdownTimeInSeconds = initialCountdownTimeInSeconds;
            sessionStorage.setItem(storedSecondsKey, String(countdownTimeInSeconds));
            displayElement.textContent = formatCountdownTime(countdownTimeInSeconds);
            return;
          }

          clearInterval(interval);
          displayElement.textContent = endedText;
          sessionStorage.removeItem(storedSecondsKey);
          return;
        }

        countdownTimeInSeconds -= 1;
        sessionStorage.setItem(storedSecondsKey, String(countdownTimeInSeconds));
        displayElement.textContent = formatCountdownTime(countdownTimeInSeconds);
      }, 1000);

      countdownIntervals[countdownKey] = interval;
    });
  }

  function initProductWidgets(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    initCurrentlyViewing(context);
    initInventoryCount(context);
    initCountdownTimers(context);
    bindInventoryVariantListeners(context);
  }

  function onEditorEvent(event) {
    if (!event || !event.target) {
      initProductWidgets(document);
      return;
    }
    initProductWidgets(event.target);
  }

  window.initSkyrocketProductWidgets = initProductWidgets;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initProductWidgets(document);
    });
  } else {
    initProductWidgets(document);
  }

  document.addEventListener('shopify:section:load', onEditorEvent);
  document.addEventListener('shopify:section:select', onEditorEvent);
  document.addEventListener('shopify:block:select', onEditorEvent);
})();
